'use strict'

const { createImmediateCmd } = require('redux-serial-effects')
const { verboseEvent } = require('../dataset-controller/verbosity')

const TYPE = 'FIRE_EVENT'

const ITEM_VALUES_CHANGED = 'itemValuesChanged'
const CURRENT_INDEX_CHANGED = 'currentIndexChanged'

const executor = (fireEvent, errorBoundaries) => ({
  type: TYPE,
  execute: cmd => {
    if (cmd.type === ITEM_VALUES_CHANGED) {
      verboseEvent(cmd.type, {
        recordBeforeChange: cmd.payload[0],
        recordAfterChange: cmd.payload[1]
      })
    } else if (cmd.type === CURRENT_INDEX_CHANGED) {
      verboseEvent(cmd.type, cmd.payload)
    }
    return errorBoundaries.userCodeZone(fireEvent)(cmd.type, ...cmd.payload)
  }
})

const fireEventCmd = (type, ...payload) =>
  createImmediateCmd(TYPE, {
    type,
    payload
  })

module.exports.executor = executor

module.exports.fireEventCmd = fireEventCmd



// WEBPACK FOOTER //
// ./helpers/fireEventExecutor.js